import MobileOffcanvas from "../modules/MobileOffсanvas";
import ProductFilter from "../modules/ProductFilter";
import ProductList from "../modules/ProductList";
import stickySidebar from "../modules/sticky-sidebar";

export default {
  init() {
    const bpLg = 'min-width: 992px';

    //Filter Offcanvaces

    const filterOC = {
      filter : new MobileOffcanvas(bpLg, '#productFilters', {
        backdrop: false,
        scroll: false,
      }, '#productFilterTrigger'),
      sort : new MobileOffcanvas(bpLg, '#productSort', {
        backdrop: false,
        scroll: false,
      }, '#productSortTrigger'),
    };

    const autoApplyBreakpoint = window.matchMedia('(min-width: 992px)');

    const filter = new ProductFilter({autoApplyBreakpoint});

    new ProductList({
        filter,
        sortOffcanvas: filterOC.sort,
        filterOffcanvas: filterOC.filter,
      });

    stickySidebar();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
